import React from 'react';
import styles from './SearchBox.module.css';
import strings from '../../../../globalization';
import searchImg from '../../../../assets/images/Fireboard/search.png';
import closeImg from '../../../../assets/images/Fireboard/close.png';

export interface SearchBoxProps {
  value: string;
  onSearchReset: Function;
  handleChange: Function;
  searchChecks: Function;
}

const SearchBox = ({ value, onSearchReset, handleChange, searchChecks }: SearchBoxProps) => (
  <div className={styles.textInputWrapper}>
    <input className={styles.textInput} type="text" value={value} onChange={handleChange} placeholder={strings.searchPlaceholder} />
    <button
      type="submit"
      onClick={searchChecks}
    >
      <img src={searchImg} className={styles.searchImage} alt="" />
    </button>
    <button
      type="submit"
      onClick={onSearchReset}
    >
      <img src={closeImg} className={styles.closeImage} alt="" />
    </button>
  </div>
);

export default SearchBox;
